import React from "react"
import { Container, List, Item } from "./styled/breadcrumb"
import { Container as MainContainer } from "../../containers"
import { Link } from "react-router-dom"

export default function Breadcrumb({ children, ...res }) {
  return (
    <Container>
      <MainContainer>{children}</MainContainer>
    </Container>
  )
}

Breadcrumb.List = function BreadcrumbList({ children, ...rest }) {
  return (
    <List {...rest}>
      <Item>
        <Link to="/">Home</Link>
      </Item>
      {children}
    </List>
  )
}

Breadcrumb.Item = function BreadcrumbItem({ to, title, ...rest }) {
  return <Item {...rest}>{to ? <Link to={to}>{title}</Link> : title}</Item>
}
